import React, { Component } from 'react';
import T from 'prop-types';
import classnames from 'classnames/bind';
import styles from './PasswordInput.mod.css';
import Icon from '../Icon/Icon';
const cn = classnames.bind(styles);

class PasswordInput extends Component {
  state = {
    isVisiable: false
  };

  changeType = () => {
    this.setState({
      isVisiable: !this.state.isVisiable
    });
  };

  render() {
    const {
      isToggeled = false,
      className = '',
      centered,
      secondary,
      invalid,
      ...otherProps
    } = this.props;
    const { isVisiable } = this.state;
    return (
      <div
        className={cn(styles.passwordWrapper, {
          centered,
          secondary
        })}
      >
        <input
          type={isVisiable ? 'text' : 'password'}
          className={cn(styles.password, className, { invalid })}
          {...otherProps}
        />
        {isToggeled && (
          <Icon
            type={isVisiable ? 'eye' : 'eye-closed'}
            onClick={this.changeType}
            className={styles.eye}
          />
        )}
        <span className={styles.border} />
      </div>
    );
  }
}

PasswordInput.propTypes = {
  className: T.string,
  secondary: T.bool,
  centered: T.bool,
  invalid: T.bool
};

export default PasswordInput;



// WEBPACK FOOTER //
// ./src/components/PasswordInput/PasswordInput.jsx